import React from 'react';
import BaseLayout from '../base-layout/index';

const SingleCol = (props) => {
  const { page } = props;

  const layout = (
    <div className="col col-md-12">
      <div className="content-container">
        {page}
      </div>
    </div>
  );

  return <BaseLayout childLayout={layout} {...props} />
}

export default SingleCol;